import karaokes from "./modules/karaokes"

export default {
    modules: {
        karaokes,
    }
}
